<template>
  <div class="campaign-view-actions">
    <ElButton
      v-if="!paused"
      :loading="isStatusLoading"
      size="mini"
      type="warning"
      @click="changeCampaignStatus"
    >
      {{ $t('ADVERTISEMENT.CAMPAIGNS.PAUSE') }}
    </ElButton>
    <ElButton
      v-else
      :loading="isStatusLoading"
      size="mini"
      type="primary"
      @click="changeCampaignStatus"
    >
      {{ $t('ADVERTISEMENT.CAMPAIGNS.RUN') }}
    </ElButton>

    <DeleteWithConfirm
      :message="deleteCampaignMessage"
      :delete-function="deleteCampaign"
    >
      {{ $t('ADVERTISEMENT.CAMPAIGN_DETAILS.DELETE_CAMPAIGN') }}
    </DeleteWithConfirm>
  </div>
</template>

<script>
import { SearchAdsCampaigns } from '@/api/api';

import DeleteWithConfirm from '@@/common/action-buttons/DeleteWithConfirm';

import campaignId from '@/mixins/advertisement/campaignId';

import {
  AD_CAMPAIGN_CHANGE_STATE,
  CAMPAIGN_STATE,
  AD_CAMPAIGN_DELETE_BUTTON,
} from '@/constants/gtm-events';

export default {
  name: 'CampaignViewActions',
  components: {
    DeleteWithConfirm,
  },
  mixins: [campaignId],
  props: {
    paused: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isStatusLoading: false,
    };
  },
  computed: {
    deleteCampaignMessage() {
      return this.$t('ADVERTISEMENT.DELETE_CAMPAIGN', {
        campaignName: this.name,
      });
    },
  },
  methods: {
    deleteCampaign() {
      this.$gtm.trackEvent(AD_CAMPAIGN_DELETE_BUTTON);

      return SearchAdsCampaigns.deleteCampaign(this.campaignId)
        .then(message => {
          this.$message.success(message);

          this.$router.replace({ name: 'advertisement-campaigns' });
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    changeCampaignStatus() {
      this.isStatusLoading = true;
      return SearchAdsCampaigns.updateCampaign({
        campaignId: this.campaignId,
        campaignInfo: {
          paused: !this.paused,
        },
      })
        .then(message => {
          this.$message.success(message);

          this.$gtm.trackEvent(
            AD_CAMPAIGN_CHANGE_STATE(
              this.paused ? CAMPAIGN_STATE.PAUSE : CAMPAIGN_STATE.RUN,
            ),
          );

          this.$emit('changeStatus');
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isStatusLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.campaign-view-actions {
  display: flex;
}
</style>
